import {defineMessages} from "react-intl";

const messages = defineMessages({
    yes:{
	id:"app.reassign-pharmacy-branch.yes",
	description:"yes",
	defaultMessage:"Yes"
    },

    reasonDoc:{
	id:"app.reassign-pharmacy-branch.reasonDoc",
	description:"reason doc",
	defaultMessage:"Upload Docs"
    }
});

export default messages;
